<template>
  <div>
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditMailTemplateDialog(true)">添加模板</el-button>
    <el-table :data="mailTemplateTableData" border size="small" style="width: 831px">
      <el-table-column prop="templateName" label="名称（不会在游戏里展示，可当作备注）" align="center" width="300">
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="150">
        <template slot-scope="scope">
          <el-popover v-model="scope.row.isTitleAndContentEverBeingViewed" placement="right" trigger="hover" width="600">
            <div v-if="scope.row.isTitleAndContentEverBeingViewed">
              <MailTemplate :languageTemplates="scope.row.languageTemplates" readonly></MailTemplate>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view">查看</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="380">
        <template slot-scope="scope">
          <el-button size="small" icon="el-icon-edit"
            @click="openEditMailTemplateDialog(false, scope.row)">修改模板</el-button>
          <el-button type="primary" size="small" icon="el-icon-s-promotion"
            @click="openSendMailDialog(scope.row)">发送邮件</el-button>
          <el-button type="primary" size="small" icon="el-icon-s-promotion"
            @click="openEditVersionMailDialog(scope.row)">新建版本邮件</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加邮件模板”对话框 -->
    <EditMailTemplateDialog v-if="shouldEditTemplateDialogVisible" @close="onEditMailTemplateDialogClosed()"
      :value="valueForEditMailTemplateDialog"></EditMailTemplateDialog>

    <!-- “发送邮件”对话框 -->
    <SendMailDialog v-if="shouldSendMailDialogVisible" @close="onSendMailDialogClosed()" :value="dataForSendMailDialog">
    </SendMailDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import MailTemplate from "@/pages/mail/components/MailTemplate";
import EditMailTemplateDialog from "../EditMailTemplateDialog";
import SendMailDialog from "../SendMailDialog";

export default {
  data() {
    return {
      shouldEditTemplateDialogVisible: false, // “添加邮件模板”对话框是否应该显示出来
      shouldSendMailDialogVisible: false, // “发送邮件”对话框是否应该显示出来
      valueForEditMailTemplateDialog: null, // 要传递给“添加邮件模板”对话框的数据
      mailTemplateTableData: [], // 邮件模板列表里展示的数据
      dataForSendMailDialog: null, // 要传递给“发送邮件”对话框的数据
    };
  },

  components: {
    MailTemplate,
    EditMailTemplateDialog,
    SendMailDialog,
  },

  async created() {
    // 拉取邮件模板集合
    await this.loadMailTemplateList();
  },

  methods: {
    /**
     * 查询邮件模板集合
     */
    async loadMailTemplateList() {
      // 清空表格数据
      this.mailTemplateTableData = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.get(
          `${util.getBackendApiBase()}/v1/admin/getMailTemplateList`,
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let mailTemplateListInResponse = resData.data.mailTemplateList || [];

      for (let mailTemplateInResponse of mailTemplateListInResponse) {
        this.mailTemplateTableData.push({
          templateId: mailTemplateInResponse.mailTemplateId,
          templateName: mailTemplateInResponse.mailTemplateName,
          languageTemplates: mailTemplateInResponse.mailTemplate,
        });
      }

      // 排序（按模板被创建的顺序倒序排列）
      this.mailTemplateTableData.sort((x, y) => {
        return Number(y.templateId) - Number(x.templateId);
      });
    },

    /**
     * 打开“添加邮件模板”对话框
     */
    async openEditMailTemplateDialog(isCreate, templateData) {
      this.shouldEditTemplateDialogVisible = true;
      this.valueForEditMailTemplateDialog = {
        isCreate: isCreate,
        templateData: templateData,
      };
    },

    /**
     * “添加邮件模板”对话框关闭了
     */
    async onEditMailTemplateDialogClosed() {
      this.shouldEditTemplateDialogVisible = false;

      // 重新拉取邮件模板集合
      return this.loadMailTemplateList();
    },

    /**
     * 打开“发送邮件”对话框
     */
    async openSendMailDialog(templateData) {
      this.shouldSendMailDialogVisible = true;
      this.dataForSendMailDialog = {
        mailTemplate: templateData,
      };
    },

    /**
     * “发送邮件”对话框关闭了
     */
    async onSendMailDialogClosed() {
      this.shouldSendMailDialogVisible = false;
    },

    /**
     * 打开版本邮件编辑框
     * 
     * @param templateData 
     */
    openEditVersionMailDialog(templateData) {
      dialogutil.open("EditVersionMailDialog", {
        data: {
          isCreate: true,
          languageTemplates: templateData.languageTemplates,
        }
      });
    },
  },
};
</script>